import { SkuDistrictReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { SkuDistrictReportGridData } from '@pages/reporting-pages/deliveries-sku-district/types/SkuDistrictReportGridData';
import { valueExist } from '@utils/typescriptGuards';
import { SkuDetailTransportTypes } from '@api/order-reporting/types-deliveries/CountryDeliveriesSkuReportDetail';



export const convertToGridData = (apiData: SkuDistrictReport[] | undefined | null): SkuDistrictReportGridData[] | null => {
	if (!apiData) return null;

	let gridData: SkuDistrictReportGridData[] = [];
	if (apiData.length === 0)
		return gridData;
	
	for (const apiDataItem of apiData) {
		const totalValue = apiDataItem.transportTypesData[SkuDetailTransportTypes.total];

		gridData.push({
			country: apiDataItem.country,
			executionPlaceName: apiDataItem.executionPlaceName,

			total_volume: totalValue && valueExist(totalValue.volume) ? totalValue.volume : 0,
			total_volumePct: totalValue && valueExist(totalValue.volumePct) ? totalValue.volumePct : 0,
			total_weight: totalValue && valueExist(totalValue.weight) ? totalValue.weight : 0,
			total_ordersCount: totalValue && valueExist(totalValue.ordersCount) ? totalValue.ordersCount : 0,
		});
	}

	return gridData;
}